const DialogConfirmNoClauseChangesContent = {
  heading: 'Confirm that you do not need to change your superannuation details',
  paragraph:
    "This is confirmation that you have received the procedural fairness letter from the trustee of your superannuation fund confirming that no changes are needed. You should only click 'confirm' if you have received this correspondence.",
  continueButton: 'Confirm',
  cancelButton: 'Cancel',
};

export default DialogConfirmNoClauseChangesContent;
